/**
 * Channel Api
 */
// 채널 등록/수정
export async function setChannel(app, userId, wsId, chType = 'P', chName = null, chId = null) {
  let params = { wsId, chType }

  if (chId) params['chId'] = chId
  if (chName) params['chName'] = chName
  else params['chName'] = 'Untitled'
  if (chType === 'P') params['chPermission'] = userId
  // TODO: 매니저/유저 권한을 지정하려면 추후 수정
  else if (chType === 'W') params['chPermission'] = 'U'

  return await app.$axios.post(`/v1/channel/${chId ? 'update' : 'create'}`, params)
}

// 채널 등록/수정
export async function setChannelDetail(
  app,
  userId,
  wsId,
  chType = 'P',
  chId = null,
  chTitle = null,
  chDescription = null,
  receivingStatus = null,
  chLogo = null
) {
  let params = { wsId, chType }

  if (chId) {
    params['chId'] = chId.includes('CH:') ? chId : `CH:${chId}`
  }
  params['chTitle'] = chTitle
  params['chDescription'] = chDescription
  if (chType === 'P') params['chPermission'] = userId
  // TODO: 매니저/유저 권한을 지정하려면 추후 수정
  else if (chType === 'W') params['chPermission'] = 'U'
  // if (chDescription) params['chDescription'] = chDescription
  if (receivingStatus) params['receivingStatus'] = receivingStatus
  if (chLogo) {
    params['chLogo'] = chLogo
  } else {
    params['chLogo'] = ''
  }

  // console.log('params! ', params)

  return await app.$axios.post(`/v1/channel/detail-update`, params)
}

// 단일 채널 조회
export async function getChannel(app, chId) {
  return await app.$axios.post('/v1/channel/info', { chId })
}

// 채널 목록 조회
export async function getChannelList(app, wsId) {
  return await app.$axios.post('/v1/channel/list', { wsId })
}

// 채널 미팅 조회
export async function getChannelMt(app, wsId, chId, chCategory, page) {
  return await app.$axios.post('/v1/channel/mt', { wsId, chId, chCategory, page })
}

// 채널 업데이트 조회
export async function getChannelUpdate(app, wsId, chId, chCategory) {
  return await app.$axios.post('/v1/channel/count', { wsId, chId, chCategory })
}

// 채널 간 미팅 이동
export async function changeMtChannel(app, wsId, oldChId, newChId, mtId, oldChCategory, newChCategory) {
  return await app.$axios.post('/v1/channel/move', {
    wsId,
    oldChId,
    newChId,
    mtId,
    oldChCategory,
    newChCategory,
  })
}

// 채널 삭제
export async function delChannel(app, wsId, chId, chCategory) {
  return await app.$axios.post('/v1/channel/delete', { wsId, chId, chCategory })
}

// Public 채널 확인
export async function chkChPublic(app, wsDomain, chId) {
  // console.log('chkMtPublic')
  return await app.$axios.post('/v1/channel/chk-public', { wsDomain, chId })
}
